import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RicercaIspettoratiComponent } from './ricerca-ispettorati.component';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [RicercaIspettoratiComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
  ],
  exports: [RicercaIspettoratiComponent],
})
export class RicercaIspettoratiModule { }
